module.exports = __webpack_public_path__ + "00c8b4cb52af121cb17a3f26191ae520.pdf";